<template>
	<div>
		<navigation msg="公共数据管理" />
		<router-view></router-view>
	</div>
</template>

<script>
	import navigation from '@/components/comm/navigation.vue'
	export default{
		data(){
			return {}
		},
		components:{
			navigation
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/uuid/home.vue